export function zip<T, U>(a: T[], b: U[]) {
    return a.map<[T, U]>((value, index) => [value, b[index]]);
}
